import React from 'react';
import ChatInterface from '../ChatInterface';

interface AgentExperienceProps {
  isDarkMode: boolean;
  onToggleTheme: () => void;
  workspaceSlug?: string;
  agentSlug?: string;
  avatarProfileSlug?: string;
  companyName?: string;
  agentName?: string;
  titleFontFamily?: string;
  brandLogoUrl?: string;
  brandIconUrl?: string;
  brandBackgroundStyle?: React.CSSProperties;
  dashboardUrl?: string;
  publicExitUrl?: string;
}

const AgentExperience: React.FC<AgentExperienceProps> = ({
  isDarkMode,
  onToggleTheme,
  workspaceSlug,
  agentSlug,
  avatarProfileSlug,
  companyName,
  agentName,
  titleFontFamily,
  brandLogoUrl,
  brandIconUrl,
  brandBackgroundStyle,
  dashboardUrl,
  publicExitUrl,
}) => {
  return (
    <div className="h-full">
      <ChatInterface
        embedded
        startWithLiveAvatar
        isDarkMode={isDarkMode}
        onToggleTheme={onToggleTheme}
        onToggleSidebar={() => {}}
        workspaceSlug={workspaceSlug}
        agentSlug={agentSlug}
        avatarProfileSlug={avatarProfileSlug}
        companyName={companyName}
        agentName={agentName}
        titleFontFamily={titleFontFamily}
        brandLogoUrl={brandLogoUrl}
        brandIconUrl={brandIconUrl}
        brandBackgroundStyle={brandBackgroundStyle}
        dashboardUrl={dashboardUrl}
        publicExitUrl={publicExitUrl}
      />
    </div>
  );
};

export default AgentExperience;
